// ─── AQI Scoring Utilities ───────────────────────────────────────────────────

export interface AirQualityData {
  co2: number;  // ppm
  tvoc: number; // mg/m³
  pm25: number; // µg/m³
}

export function scoreCO2(ppm: number): number {
  if (ppm < 800) return 100;
  if (ppm < 1200) return 70;
  if (ppm < 2000) return 40;
  return 10;
}

export function scoreTVOC(mgm3: number): number {
  if (mgm3 < 0.3) return 100;
  if (mgm3 < 0.6) return 70;
  if (mgm3 < 1.0) return 40;
  return 10;
}

export function scorePM25(ugm3: number): number {
  if (ugm3 < 15) return 100;
  if (ugm3 < 35) return 70;
  if (ugm3 < 75) return 40;
  return 10;
}

export function overallAqiScore(data: AirQualityData): number {
  const co2Score = scoreCO2(data.co2);
  const tvocScore = scoreTVOC(data.tvoc);
  const pm25Score = scorePM25(data.pm25);
  return (co2Score + tvocScore + pm25Score) / 3;
}

export interface AQIGrade {
  label: string;
  color: string;
  bgColor: string;
  description: string;
}

export function getAQIGrade(score: number): AQIGrade {
  if (score >= 80)
    return {
      label: 'aqi.good',
      color: 'text-emerald-400',
      bgColor: 'bg-emerald-500/20',
      description: 'aqi.desc_good',
    };
  if (score >= 60)
    return {
      label: 'aqi.normal',
      color: 'text-cyan-400',
      bgColor: 'bg-cyan-500/20',
      description: 'aqi.desc_normal',
    };
  if (score >= 40)
    return {
      label: 'aqi.bad',
      color: 'text-amber-400',
      bgColor: 'bg-amber-500/20',
      description: 'aqi.desc_bad',
    };
  return {
    label: 'aqi.very_bad',
    color: 'text-red-400',
    bgColor: 'bg-red-500/20',
    description: 'aqi.desc_very_bad',
  };
}

